import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectedProduct {
  id: string;
  name: string;
  description: string;
  organizationId: string;
  price: number;
  images: string;
  quantity: string;
}

export interface SelectedProductState {
  selectedProduct: SelectedProduct[];
  searchedProducts: SelectedProduct[];
}

const initialState: SelectedProductState = {
  selectedProduct: [],
  searchedProducts: [],
};

export const selectedProductSlice = createSlice({
  name: "selectedProducts",
  initialState,
  reducers: {
    resetSelectedProduct: (state: any) => {
      state.selectedProduct = [];
    },

    addSelectedProduct: (state, action: PayloadAction<SelectedProduct>) => {
      console.log(action);

      state.selectedProduct.push(action.payload);
    },

    deleteSelectedProduct: (state, action: PayloadAction<string>) => {
      const productIdToDelete = action.payload;
      state.selectedProduct = state.selectedProduct.filter(
        (product) => product.id !== productIdToDelete
      );
    },

    setSearchedProducts: (state, action: PayloadAction<SelectedProduct[]>) => {
      state.searchedProducts = action.payload;
    },

    clearSearchedProducts: (state) => {
      state.searchedProducts = [];
    },
  },
});

export const {
  addSelectedProduct,
  deleteSelectedProduct,
  resetSelectedProduct,
  setSearchedProducts,
  clearSearchedProducts,
} = selectedProductSlice.actions;
export default selectedProductSlice.reducer;
